export const text = {
  street: "860 North Dorothy Drive Suite 600",
  city: "Richardson, TX 75081",
  phone: "972-480-0888",
  fax: "972-480-8884",
  email: "service@trastarusa.com",
};
